import React, { useState } from "react";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  Card,
  Upload,
  Image,
  Collapse,
} from "antd";
// Drag & Drop
import { DndContext, PointerSensor, useSensor } from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
const { Panel } = Collapse;

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const DraggableUploadListItem = ({ originNode, file }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: file.uid,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: "move",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      // prevent preview event when drag end
      className={isDragging ? "is-dragging" : ""}
      {...attributes}
      {...listeners}
    >
      {/* hide error tooltip when dragging */}
      {file.status === "error" && isDragging
        ? originNode.props.children
        : originNode}
    </div>
  );
};

const Map = ({ fileList, setFileList, information }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  console.log("fileList", fileList);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const sensor = useSensor(PointerSensor, {
    activationConstraint: { distance: 10 },
  });

  const onDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    setFileList((prev) => {
      const activeIndex = prev.findIndex((item) => item.uid === active.id);
      const overIndex = prev.findIndex((item) => item.uid === over.id);

      if (activeIndex === -1 || overIndex === -1) return prev;

      const updated = [...prev];

      // Swap items
      const temp = updated[activeIndex];
      updated[activeIndex] = updated[overIndex];
      updated[overIndex] = temp;

      return updated;
    });
  };

  // handler to show uploaded files
  const floorImageHandler = (index) => {
    if (
      information !== null &&
      information?.floorPlans &&
      typeof information?.floorPlans[index]?.floorPlanImage === "string"
    ) {
      return (
        <Image
          src={information?.floorPlans[index]?.floorPlanImage}
          onPreview={handlePreview}
          style={{ width: 200 }}
        />
      );
    } else {
      return "";
    }
  };

  // listTagHandler for mata tags
  const listTagHandler = (index, value, key) => {
    let updatedObject = [...fileList];
    updatedObject[index][key] = value;
    setFileList(updatedObject);
    console.log("fileList", fileList);
    console.log("updatedObject", updatedObject);
  };

  return (
    <div className="video-url-container images-cover-container">
      <h4 style={{ padding: "10px 0px" }}>Images</h4>
      <DndContext sensors={[sensor]} onDragEnd={onDragEnd}>
        <SortableContext
          items={fileList.map((i) => i.uid)}
          strategy={verticalListSortingStrategy}
        >
          <Upload
            beforeUpload={() => false}
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            onChange={handleChange}
            multiple
            itemRender={(originNode, file) => (
              <DraggableUploadListItem originNode={originNode} file={file} />
            )}
          >
            {uploadButton}
          </Upload>
        </SortableContext>
      </DndContext>
      {previewImage && (
        <Image
          wrapperStyle={{ display: "none" }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
      {/* ALT DESCRIPTION OF IMAGES */}
      {/* Label Background Color */}
      {fileList?.length > 0 && (
        <>
          <h4 style={{ padding: "20px 0px 10px 0px" }}></h4>
          <Collapse defaultActiveKey={false}>
            <Panel header="Images Meta Tags" key="1" showArrow={false}>
              {fileList?.map((item, index) => (
                <div className="gallery-images-meta-tags">
                  <h4 style={{ padding: "10px 0px" }}>Image # {index + 1}</h4>
                  <Form.Item label="Alt Text">
                    <Input
                      className="input-tag"
                      value={item?.alt_title}
                      onChange={(e) => {
                        listTagHandler(index, e.target.value, "alt_title");
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="Meta Title">
                    <Input
                      className="input-tag"
                      value={item?.meta_title}
                      onChange={(e) => {
                        listTagHandler(index, e.target.value, "meta_title");
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="Meta Description">
                    <Input
                      className="input-tag"
                      value={item?.meta_description}
                      onChange={(e) => {
                        listTagHandler(
                          index,
                          e.target.value,
                          "meta_description"
                        );
                      }}
                    />
                  </Form.Item>
                </div>
              ))}
            </Panel>
          </Collapse>
        </>
      )}
      {/* Label Background Color */}
      <h4 style={{ padding: "30px 0px 10px 0px" }}>Floor Plans</h4>
      <div>
        <Form.List name="floorPlans">
          {(fields, { add, remove }) => (
            <div
              style={{ display: "flex", rowGap: 16, flexDirection: "column" }}
            >
              {fields.map((field) => (
                <Card
                  size="small"
                  title={`Floor Plan ${field.name + 1}`}
                  key={field.key}
                  extra={
                    <CloseOutlined
                      onClick={() => {
                        remove(field.name);
                      }}
                    />
                  }
                >
                  <Form.Item
                    label="Floor Name"
                    name={[field.name, "floorName"]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item label="image" name={[field.name, "floorImage"]}>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture-card"
                      maxCount={1}
                      onPreview={handlePreview}
                    >
                      {uploadButton}
                    </Upload>
                  </Form.Item>
                  <div>
                    {floorImageHandler(field?.key) !== "" && (
                      <h4>Upload Floor Plan Image</h4>
                    )}
                    <div className="py-5">{floorImageHandler(field?.key)}</div>
                  </div>
                </Card>
              ))}

              <Button type="dashed" onClick={() => add()} block>
                + Add Item
              </Button>
            </div>
          )}
        </Form.List>
      </div>
    </div>
  );
};

export default Map;
